module.exports = __webpack_public_path__ + "static/media/logo_awerweb_horiz_branca.3975a042.svg";